import {
  AppBar,
  Avatar,
  Box,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
} from "@mui/material";
import styled from "@emotion/styled";
import { Menu as MenuIcon, MoreVert as MoreIcon } from "@mui/icons-material";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import { useCallback, useEffect, useState } from "react";
import { START_SCREEN_ROUTE } from "../../routes";
import { useNavigate } from "react-router-dom";
import { drawerWidth } from "../../utils/constants";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  handleDrawerClose,
  handleDrawerOpen,
  handleMobileDrawerOpen,
} from "../../features/dashboard/dashboardSlice";
import { AuthRole } from "../../utils/roles";
import AppModal from "../common/AppModal";
import AppSnackbar from "../common/AppSnackbar";
import SendSmsModel from "./sendSmsModel";
import SendOtpModel from "./sendOtpModel";
import { ProfileModal } from "../profile/profile-model";
import { getProfileData } from "../../features/profile/profileSlice";
import { getPharmacyImage } from "../../utils/utils";
import { logout } from "../../features/auth/authSlice";
import AppButton from "../common/AppButton";
import { NEWSALE_DASHBOARD_SCREEN_ROUTE } from "../../routes";
const DashboardAppBar = styled(AppBar)(({ theme }: any) => ({
  backgroundColor: "white",
  boxShadow: "none",
  borderBottom: "1px solid #C4C4C4",
}));
export const DashboardNavbar = ({ lgUp, profileInfo, clinicProfile }: any) => {
  const dispatch = useAppDispatch();
  const { drawer } = useAppSelector((state: any) => state.dashboard);
  const [openModal, setOpenModal] = useState(false);
  const [openProfileModal, setOpenProfileModal] = useState(false);
  const [opeEmailnModal, setOpeEmailnModal] = useState(false);
  const [openOtpModal, setOpenOtpModal] = useState(false);
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);
  const handlEmaileOpenModal = () => setOpeEmailnModal(true);
  const handlOtpOpenModal = () => setOpenOtpModal(true);
  const handleOtpCloseModal = () => setOpenOtpModal(false);
  const handleEmailCloseModal = () => setOpeEmailnModal(false);
  const handleOpenProfileModal = () => setOpenProfileModal(true);
  const staff_data = localStorage.getItem("staff_data");
  const StaffData = staff_data ? JSON.parse(staff_data) : null;
  const Staff_token = StaffData?.token;

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { name }: any = AuthRole();
  const menuId = "primary-search-account-menu";
  const mobileMenuId = "primary-search-account-menu-mobile";
  const isMenuOpen = Boolean(anchorEl);
  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleNewSale = () => {
    navigate(NEWSALE_DASHBOARD_SCREEN_ROUTE);
  };

  //const storedData: any = localStorage.getItem("pharmacyId");
  //const parsedData = JSON.parse(storedData);

  // Use useAppSelector to access Redux state

  const profilename: any = useAppSelector((state) => state?.profile);
  const [selectData, setselectData]: any = useState(profilename);
  const [profileData, setProfileData] = useState<any>(null);
  const [imageTimestamp, setImageTimestamp] = useState(Date.now());

  const pharmacyId = localStorage?.getItem("pharmacyId");

  const getProfile = useCallback(() => {
    if (pharmacyId) {
      dispatch(getProfileData(pharmacyId))
        .then((response) => {
          setProfileData(response?.payload);
        })
        .catch((error) => {
          console.error("Error fetching profile data:", error);
        });
    } else {
      console.error("No Pharmacy Id found");
    }
  }, [dispatch, pharmacyId]);

  useEffect(() => {
    getProfile();
  }, [getProfile]);

  const handleCloseProfileModal = () => {
    setOpenProfileModal(false);
    getProfile();
    // window.location.reload();
    setImageTimestamp(Date.now());
  };

  const pharmacy_id = profilename?.profileDetails?.pharmacy?.id;

  if (pharmacy_id) {
    localStorage.setItem("pharmacyId", pharmacy_id); // Storing id in localStorage
  }

  const handleProfileClick = () => {
    <ProfileModal
      getProfile={getProfile}
      profileInfo={profileInfo}
      clinicProfile={clinicProfile}
      profileData={profileData}
    />;

    handleOpenProfileModal();
    handleMenuClose(); // Close menu after clicking profile
  };

  // const handleLogout = () => {
  //   localStorage.removeItem("pharmacyAuthToken");
  //   localStorage.removeItem("salesData");
  //   localStorage.removeItem("pharmacyId");
  //   navigate(LOGIN_SCREEN_ROUTE);
  //   handleMenuClose();
  //   window.location.reload();
  // };

  // const handleLogout = () => {
  //   authService.logout(auth).then((res: any) => {
  //     if (res.success === true) {
  //       if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
  //         navigate(START_SCREEN_ROUTE);
  //         window.location.reload();
  //       } else {
  //         window.location.href = "https://e-mareez.com/";
  //       }
  //       handleMenuClose();
  //       localStorage.removeItem("pharmacyAuthToken");
  //       localStorage.removeItem("salesData");
  //       localStorage.removeItem("pharmacyId");
  //     }
  //   });
  //   setselectData(localStorage.getItem(setselectData));
  // };

  const handleLogout = () => {
    const auth_data = localStorage.getItem("pharmacyAuthToken");
    const AuthData = auth_data ? JSON.parse(auth_data) : null;
    const bearerToken = AuthData; // Renamed to match expected key
    dispatch(logout({ bearerToken: bearerToken, staff_token: Staff_token }))
      .then((res: any) => {
        if (res?.payload?.success === true) {
          if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
            navigate(START_SCREEN_ROUTE);
            window.location.reload();
          } else {
            window.location.href = "https://e-mareez.com/";
          }
          handleMenuClose();
          localStorage.removeItem("pharmacyAuthToken");
          localStorage.removeItem("salesData");
          localStorage.removeItem("pharmacyId");
          localStorage.removeItem("staff_data");
          localStorage.removeItem("type");
          localStorage.removeItem("is_free_trail");
        } else {
          alert(res?.payload);
        }
      })
      .catch((error: any) => {
        console.error("Logout error:", error);
        alert("An unexpected error occurred. Please try again.");
      });
  };

  const { user }: any = AuthRole();
  const renderMobileMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={handleProfileClick}>Profile</MenuItem>
      <MenuItem onClick={handleLogout}>Logout</MenuItem>
    </Menu>
  );
  return (
    <>
      <Box sx={{ flexGrow: 1 }}>
        <DashboardAppBar
          sx={{
            display: "flex",
            justifyContent: "space-between",

            left: {
              lg: drawer ? drawerWidth : 66,
            },
            width: {
              lg: drawer ? "calc(100% - 240px)" : "calc(100% - 66px)",
            },
          }}
        >
          <Toolbar
            disableGutters
            sx={{
              minHeight: 64,
              left: 0,
              px: 2,
            }}
          >
            <IconButton
              onClick={() =>
                !lgUp
                  ? dispatch(handleMobileDrawerOpen())
                  : drawer
                  ? dispatch(handleDrawerClose())
                  : dispatch(handleDrawerOpen())
              }
              sx={{
                display: {
                  xs: "inline-flex",
                },
              }}
            >
              {drawer ? (
                <MenuOpenIcon sx={{ color: "#000" }} />
              ) : (
                <MenuIcon sx={{ color: "#000" }} />
              )}
            </IconButton>
            <Box>
              <AppButton
                title={"Add New Sale"}
                onClick={handleNewSale}
              ></AppButton>
            </Box>
            {/* <SearchBar /> */}
            <Box sx={{ flexGrow: 1 }} />

            <Typography
              sx={{
                color: "text.primary",
                pl: 1,
              }}
              variant="body1"
            >
              {user}
            </Typography>
            <Box
              sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
              onClick={handleProfileClick}
            >
              <Avatar
                sx={{ bgcolor: "secondary.main" }}
                src={`${getPharmacyImage(pharmacy_id)}&t=${imageTimestamp}`}
                // src={
                //   getPharmacyImage(pharmacy_id)
                // }
              >
                {/* {getInitials(profilename?.profileDetails?.name)} */}
              </Avatar>

              <Typography sx={{ color: "text.primary", pl: 1 }} variant="body1">
                {profilename?.profileDetails?.user?.name}
              </Typography>
            </Box>
            <Box>
              <IconButton
                size="large"
                aria-label="show more"
                aria-controls={mobileMenuId}
                aria-haspopup="true"
                onClick={handleProfileMenuOpen}
              >
                <MoreIcon />
              </IconButton>
              <MoreIcon />
            </Box>
          </Toolbar>
        </DashboardAppBar>
        {renderMobileMenu}
      </Box>
      <AppModal
        title="Pharmacy Profile"
        open={openProfileModal}
        handleClose={handleCloseProfileModal}
        fullScreen={false}
        maxWidth="lg"
      >
        <ProfileModal
          getProfile={getProfile}
          profileInfo={profileInfo}
          clinicProfile={clinicProfile}
          profileData={profileData}
        />
      </AppModal>
      <AppModal
        title="Send OTP"
        open={openOtpModal}
        handleClose={handleOtpCloseModal}
        fullScreen={false}
        maxWidth="sm"
      >
        <SendOtpModel
          handleClose={handleOtpCloseModal}
          setOpenSnackbar={() => setOpenSnackbar(true)}
        />
      </AppModal>

      <AppModal
        title="Send SMS"
        open={openModal}
        handleClose={handleCloseModal}
        fullScreen={false}
        maxWidth="sm"
      >
        <SendSmsModel
          handleClose={handleCloseModal}
          setOpenSnackbar={() => setOpenSnackbar(true)}
          appoinmentId={"appointment.id"}
        />
      </AppModal>
      <AppSnackbar
        message="Successfully Added!"
        open={openSnackbar}
        handleClose={() => setOpenSnackbar(false)}
      />
    </>
  );
};
